var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('job-filters'),_c('organization-form',{attrs:{"loading":_vm.loading},on:{"submit":_vm.createOrganization}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }